import {Component, computed, input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';

@Component({
  selector: 'app-iackathon-step-deliverable',
    imports: [
        TranslateModule
    ],
  templateUrl: './iackathon-step-deliverable.component.html',
  styleUrl: './iackathon-step-deliverable.component.scss',
})
export class IackathonStepDeliverableComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save()?.attributes.content.state);
    private deliverable = computed(() => this.state().deliverable);
    protected format = computed(() => this.deliverable().format);
    protected label = computed(() => this.deliverable().is_external ? this.deliverable().url : this.deliverable().filename);

}
